(function () {
  const STORAGE_KEY = 'laylaWishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function isSaved(productId) {
    return getWishlist().some(
      item => String(item.id) === String(productId)
    );
  }

  function updateButton(button, saved) {
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');

    const title = button.dataset.productTitle || 'product';

    button.setAttribute(
      'aria-label',
      saved
        ? `Remove ${title} from wishlist`
        : `Add ${title} to wishlist`
    );
  }

  function initialiseButtons() {
    document.querySelectorAll('[data-wishlist-button]').forEach(button => {
      updateButton(button, isSaved(button.dataset.productId));
    });
  }

  function toggleWishlist(button) {
    const product = {
      id: button.dataset.productId,
      handle: button.dataset.productHandle,
      title: button.dataset.productTitle,
      url: button.dataset.productUrl
    };

    let wishlist = getWishlist();

    const existingIndex = wishlist.findIndex(
      item => String(item.id) === String(product.id)
    );

    if (existingIndex > -1) {
      wishlist.splice(existingIndex, 1);
      saveWishlist(wishlist);
      updateButton(button, false);
    } else {
      wishlist.push(product);
      saveWishlist(wishlist);
      updateButton(button, true);
      if (
  window.Shopify &&
  Shopify.analytics &&
  typeof Shopify.analytics.publish === 'function'
) {
  Shopify.analytics.publish('layla_add_to_wishlist', {
    item_id: product.id,
    item_name: product.title,
    currency: 'GBP'
  });
  }
}
updateWishlistCount();
    renderWishlistPage();
  }

  async function getProductData(handle) {
    try {
      const response = await fetch(`/products/${handle}.js`);

      if (!response.ok) return null;

      return await response.json();
    } catch (e) {
      return null;
    }
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format(cents / 100);
  }

  async function renderWishlistPage() {
    const grid = document.querySelector('[data-wishlist-grid]');
    const empty = document.querySelector('[data-wishlist-empty]');

    if (!grid || !empty) return;

    const wishlist = getWishlist();

    grid.innerHTML = '';

    if (!wishlist.length) {
      empty.hidden = false;
      return;
    }

    empty.hidden = true;

    for (const item of wishlist) {
      const product = await getProductData(item.handle);

      if (!product) continue;

      const card = document.createElement('article');
      card.className = 'layla-wishlist-card';

      const image = product.featured_image
        ? `<img src="${product.featured_image}" alt="${product.title}" loading="lazy">`
        : '';

      card.innerHTML = `
        <div class="layla-wishlist-card__image">
          <a href="${product.url}">
            ${image}
          </a>

          <button
            type="button"
            class="layla-wishlist-remove"
            data-wishlist-remove="${product.id}"
            aria-label="Remove ${product.title} from wishlist"
          >
            ×
          </button>
        </div>

        <div class="layla-wishlist-card__details">
          <a href="${product.url}" class="layla-wishlist-card__title">
            ${product.title}
          </a>

          <div class="layla-wishlist-card__price">
            ${formatMoney(product.price)}
          </div>

          <a href="${product.url}" class="layla-wishlist-card__view">
            View product
          </a>
        </div>
      `;

      grid.appendChild(card);
    }
  }

  function removeFromWishlist(productId) {
    const wishlist = getWishlist().filter(
      item => String(item.id) !== String(productId)
    );

    saveWishlist(wishlist);
    updateWishlistCount();
    initialiseButtons();
    renderWishlistPage();
  }

  document.addEventListener('click', function (event) {
    const wishlistButton = event.target.closest('[data-wishlist-button]');

    if (wishlistButton) {
      event.preventDefault();
      event.stopPropagation();
      toggleWishlist(wishlistButton);
      return;
    }

    const removeButton = event.target.closest('[data-wishlist-remove]');

    if (removeButton) {
      event.preventDefault();
      removeFromWishlist(removeButton.dataset.wishlistRemove);
    }
  });
function updateWishlistCount() {
  const countElement = document.querySelector('[data-wishlist-count]');

  if (!countElement) return;

  const count = getWishlist().length;

  if (count > 0) {
    countElement.textContent = count;
    countElement.hidden = false;
  } else {
    countElement.textContent = '';
    countElement.hidden = true;
  }
}

function initWishlist() {
  initialiseButtons();
  renderWishlistPage();
  updateWishlistCount();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWishlist, { once: true });
} else {
  initWishlist();
}

})();